/**
 * DepartingEmployeeBanner — уведомление уволенному сотруднику о режиме
 * «передача дел». Показывается в Layout под header'ом, если у user'а
 * linked_employee_status === 'terminated'.
 *
 * Industry pattern: BambooHR self-service window banner, Workday alumni
 * portal notice. Назначение — объяснить, почему меню сократилось и куда
 * идти заполнять описание должности.
 *
 * NOTE: кнопка намеренно использует <a href> вместо <Link> — это форсирует
 * полный page reload, чтобы браузер загрузил свежий JS-бандл без старого
 * ProtectedRoute на /erp/offboarding/handover.
 */

import { AlertCircle, FileText } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function DepartingEmployeeBanner() {
    const { user } = useAuth()
    if (user?.linked_employee_status !== 'terminated') return null

    return (
        <div
            style={{
                padding: '10px 16px',
                background: 'var(--color-warning-bg)',
                borderBottom: '1px solid color-mix(in srgb, var(--color-warning) 40%, transparent)',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                flexWrap: 'wrap',
            }}
            className='text-rel-sm'
        >
            <AlertCircle size={16} style={{ color: 'var(--color-warning)' }} />
            <span>
                <b>Режим передачи дел.</b> Доступны только личный кабинет,
                поддержка и страница «Описание должности и передача дел».
                Закройте задачу — нажмите «Отправить» в описании, и
                HR-команда закроет аккаунт после приёма дел.
            </span>
            <a
                href="/erp/offboarding/handover"
                className="btn btn--toolbar btn--sm flex items-center gap-4"
                style={{ marginLeft: 'auto', textDecoration: 'none' }}
            >
                <FileText size={13} /> Описать свою работу
            </a>
        </div>
    )
}
